import { runListenersForEvent } from 'core_main/helpers/events';
import {
  ON_MESSAGE_RECEIVED_EVENT_TYPE,
  ON_UNREAD_COUNT_CHANGE_EVENT_TYPE,
  ON_AGENT_TYPING_ACTIVITY,
} from 'core/constants';
import { createMessageCallbackResponse } from 'core_main/sdk/send_message/helpers';
import {
  ChatMessagesData,
  GetChatMessageAttachmentsData,
} from 'core_main/api/messages/types';
import {
  getUnreadCountsFromStore,
  incrementUnreadCountInStore,
} from 'core_main/store';
import { UserAttributes } from 'core_main/api/users/types';
import { SignalEvent } from 'pubnub';

import {
  UserTypingResponse,
  Included,
  OnUnreadCountChangeCallbackResponse,
  PubNubChatSessionMergedMessageEvent,
  ConversationMergedCallbackResponse,
} from './types';
import { USER_TYPING } from './constants';

export const createConversationChannelGroupString = (customerId, orgId) => {
  return `ext-convo-group-${orgId}.cust-${customerId}`;
};

export const createMetaCustomerChannelString = (customerId, orgId) => {
  return `ext-meta-cust-${orgId}.cust-${customerId}`;
};

export const createSharedCustomerChannelString = (customerId, orgId) => {
  return `shrd-cust-${orgId}.cust-${customerId}`;
};
export const runListenersForOnUnreadCountChangeEvent = (sessionId) => {
  const unreadCounts = getUnreadCountsFromStore();

  const callbackResponse: OnUnreadCountChangeCallbackResponse = {
    total: unreadCounts.total,
    change: {
      conversationId: sessionId,
      count: unreadCounts.conversations[sessionId],
    },
  };

  runListenersForEvent(ON_UNREAD_COUNT_CHANGE_EVENT_TYPE, callbackResponse);
};
export const runListenersForOnMessageReceivedEvent = (
  message: ChatMessagesData,
  attachmentData?: GetChatMessageAttachmentsData[],
  includedData?: Included[],
) => {
  const messageCallbackResponse = createMessageCallbackResponse(
    message,
    attachmentData,
    includedData,
  );

  const sessionId = message.relationships.session.data.id;

  incrementUnreadCountInStore(sessionId);

  const sentByType = message?.relationships?.sentBy?.data?.type;

  if (sentByType === 'user') {
    runListenersForOnUnreadCountChangeEvent(sessionId);
  }

  runListenersForEvent(ON_MESSAGE_RECEIVED_EVENT_TYPE, messageCallbackResponse);
};

export const createUserTypingResponse = (
  event,
  user: UserAttributes,
): UserTypingResponse => {
  const { channel, message } = event;

  const conversationId = channel.split('.convo-')[1];

  const typing = message === USER_TYPING;

  return {
    conversationId,
    user,
    typing,
  };
};

export const createChatSessionMergedCallbackResponse = (
  event: PubNubChatSessionMergedMessageEvent,
): ConversationMergedCallbackResponse => {
  const { data } = event;
  const { relationships } = data;
  const { source, target } = relationships;
  const { id: sourceId } = source.data;
  const { id: targetId } = target.data;

  return {
    sourceConversationId: sourceId,
    targetConversationId: targetId,
  };
};

export const runListenersForUserTypingEvent = (
  signalEvent: SignalEvent,
  user: UserAttributes,
) => {
  const callbackResponse = createUserTypingResponse(signalEvent, user);
  runListenersForEvent(ON_AGENT_TYPING_ACTIVITY, callbackResponse);
};
